/**
 * AdminLayout — zentrales Rollen-Gate fuer alle /admin-Unterseiten.
 *
 * Haengt an der Layout-Route routes/_auth.admin.tsx; jede _auth.admin.*-Route
 * ist damit automatisch abgesichert, statt den Guard wie bisher in jede
 * Admin-Seite zu kopieren.
 *
 * Bewusst KEIN beforeLoad-Redirect: der userStore ist nicht persistiert
 * (stores/userStore.ts), nach einem Reload ist `user` null, bis useAccount
 * geantwortet hat. Ein synchroner Guard wuerde den Admin beim Direktaufruf oder
 * Reload einer Admin-Seite hinauswerfen. Deshalb wird erst umgeleitet, wenn der
 * Account wirklich geladen ist (isLoaded) — siehe useUserPermissions.
 */
import { useEffect } from 'react'
import { Outlet, useNavigate } from '@tanstack/react-router'
import { useUserPermissions } from '../../hooks/useUserPermissions'

export function AdminLayout() {
  const { isAdmin, isLoaded } = useUserPermissions()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoaded && !isAdmin) {
      navigate({ to: '/dashboard', replace: true })
    }
  }, [isLoaded, isAdmin, navigate])

  if (!isAdmin) return null

  return <Outlet />
}
